import React, { createContext, useContext, useState } from 'react';
import type { ArticleTag } from '@/types/articles';

interface ArticleTagContextType {
  isOpen: boolean;
  editingTag: ArticleTag | null;
  openAddTag: () => void;
  openEditTag: (tag: ArticleTag) => void;
  closeTagDialog: () => void;
}

const ArticleTagContext = createContext<ArticleTagContextType | undefined>(undefined);

export const ArticleTagProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingTag, setEditingTag] = useState<ArticleTag | null>(null);

  const openAddTag = () => {
    setEditingTag(null);
    setIsOpen(true);
  };

  const openEditTag = (tag: ArticleTag) => {
    setEditingTag(tag);
    setIsOpen(true);
  };

  const closeTagDialog = () => {
    setIsOpen(false);
    setEditingTag(null);
  };

  return (
    <ArticleTagContext.Provider 
      value={{ 
        isOpen, 
        editingTag, 
        openAddTag, 
        openEditTag, 
        closeTagDialog 
      }}
    >
      {children}
    </ArticleTagContext.Provider>
  );
};

export const useArticleTagDialog = () => {
  const context = useContext(ArticleTagContext);
  if (context === undefined) {
    throw new Error('useArticleTagDialog must be used within an ArticleTagProvider');
  }
  return context;
};
